
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7WjUL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $e4o8D = parcelRequire("e4o8D");


var $bQm3c = parcelRequire("bQm3c");





var $bRblh = parcelRequire("bRblh");

/**
 * Analytics-attribution tag for opens triggered by the Confluence deep link.
 * A local string (not added to the platform `RovoSettingsModalSurface` enum,
 * which is for surfaces with an active experiment); a non-`search-*` surface
 * already defaults the discovery tab on.
 */ const $bde2a39acd550407$var$CONNECTOR_DEEP_LINK_SURFACE = 'confluence-deep-link';
/**
 * Opens the modal once when `isActive` becomes true, then re-arms when it goes
 * false (e.g. after the URL is cleaned up) so a later re-appearance opens again.
 *
 * Receives the modal's stable `open` as a prop and calls it from an effect — the
 * open trigger and the ref guard live in the commit phase, never during render.
 */ const $bde2a39acd550407$var$OpenOnActive = ({ open: open, isActive: isActive, onHandled: onHandled })=>{
    const openedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (isActive) {
            if (!openedRef.current) {
                openedRef.current = true;
                open({
                    defaultTab: 'discovery'
                });
                onHandled();
            }
        } else openedRef.current = false;
    }, [
        isActive,
        open,
        onHandled
    ]);
    return null;
};
const $bde2a39acd550407$export$244bb8141909b27b = ({ cloudId: cloudId, isActive: isActive, onHandled: onHandled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bRblh.RovoSettingsModal), {
        product: "confluence",
        cloudId: cloudId,
        surface: $bde2a39acd550407$var$CONNECTOR_DEEP_LINK_SURFACE
    }, ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($bde2a39acd550407$var$OpenOnActive, {
            open: open,
            isActive: isActive,
            onHandled: onHandled
        }));






var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");

const $26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM = 'add-connector';
const $26bd1ca50d63a453$var$SOURCE_PARAM = 'source';
/**
 * Embed/standalone routes where the deep link must never act, even if the param
 * is present. Admin needs no entry here: admin routes are not part of the SPA
 * `routeComponents`, so `GlobalComponents` (and therefore this hook) never
 * renders on them.
 */ const $26bd1ca50d63a453$var$EXCLUDED_ROUTE_NAMES = new Set([
    (0, $1NBp8.EDIT_PAGE_EMBED).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EMBEDDED_MULTIPLE_SUBCALENDAR).name,
    (0, $1NBp8.SPACE_EMBEDDED_SUBCALENDAR).name
]);
const $26bd1ca50d63a453$export$bab0da7564a2aae5 = ()=>{
    const { match: match, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const query = match?.query ?? {};
    const isExcludedRoute = match?.name ? $26bd1ca50d63a453$var$EXCLUDED_ROUTE_NAMES.has(match.name) : false;
    const isDeepLinkActive = $26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM in query && !isExcludedRoute;
    const markHandled = (0, $42omo.useCallback)(()=>{
        // `setQueryParams` merges then deletes null/undefined keys, so this removes
        // our params and is a no-op for any that aren't present.
        setQueryParams({
            [$26bd1ca50d63a453$var$ADD_CONNECTOR_PARAM]: undefined,
            [$26bd1ca50d63a453$var$SOURCE_PARAM]: undefined
        }, true);
    }, [
        setQueryParams
    ]);
    return {
        isDeepLinkActive: isDeepLinkActive,
        markHandled: markHandled
    };
};


const $ae5162257a940ecc$export$ac11f5dd0a537404 = ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [everActive, setEverActive] = (0, $42omo.useState)(false);
    const { isDeepLinkActive: isDeepLinkActive, markHandled: markHandled } = (0, $26bd1ca50d63a453$export$bab0da7564a2aae5)();
    // Default to {} so we no-op rather than throw if rendered without a
    // SessionDataContext provider (e.g. in isolation tests).
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)() ?? {};
    (0, $42omo.useEffect)(()=>{
        if (isDeepLinkActive) setEverActive(true);
    }, [
        isDeepLinkActive
    ]);
    if (renderServerPlaceholder || !everActive || !isRovoEnabled || !cloudId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bde2a39acd550407$export$244bb8141909b27b), {
        cloudId: cloudId,
        isActive: isDeepLinkActive,
        onHandled: markHandled
    });
};
module.exports["ConnectorDeepLink"] = $ae5162257a940ecc$export$ac11f5dd0a537404;

});

parcelRegister("bRblh", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $aXWIB = parcelRequire("aXWIB");


var $tvI67 = parcelRequire("tvI67");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $7ZiAi = parcelRequire("7ZiAi");

const $760b34ee18927bc0$var$triggerStyles = {
    button: "_1dqoglyw _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _bfhk1j28 _80omtlke _1bsb1osq _irr31dpa",
    text: "_11c8wadc _syaz1rpy"
};
const $760b34ee18927bc0$var$DefaultTrigger = ({ open: open })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        xcss: $760b34ee18927bc0$var$triggerStyles.button,
        onClick: ()=>open()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        alignItems: "center",
        gap: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($tvI67))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $760b34ee18927bc0$var$triggerStyles.text
    }, formatMessage((0, $7ZiAi.messages).defaultTriggerLabel))));
};

const $760b34ee18927bc0$var$LazyRovoSettingsModalProvider = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("4OJMa")).then((mod)=>({
            default: mod.RovoSettingsModalLazy
        }))); /**
       * Self-contained entrypoint for the Rovo Settings modal.
       *
       * The trigger renders eagerly. The provider tree and modal
       * are lazy-loaded only when the user first clicks the trigger.
       * Subsequent opens reuse the mounted provider — no re-mount or re-fetch.
       */ 
const $760b34ee18927bc0$export$f2c3f3e62df426ba = ({ children: renderTrigger, ...providerProps })=>{
    const [isActivated, setIsActivated] = (0, $42omo.useState)(false);
    const pendingOpenOptions = (0, $42omo.useRef)(undefined);
    const openModalRef = (0, $42omo.useRef)(null);
    const open = (0, $42omo.useCallback)((options)=>{
        if (openModalRef.current) // Provider already mounted — open directly
        openModalRef.current(options);
        else {
            // First click — store options and mount the provider
            pendingOpenOptions.current = options;
            setIsActivated(true);
        }
    }, []); // Calling the render function directly (rather than mounting it as a
    // component) makes React diff the returned JSX in-place against the previous
    // render, so the trigger element survives parent re-renders even if the
    // render function's identity changes (e.g. inline arrows).
    const triggerNode = renderTrigger ? renderTrigger({
        open: open
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($760b34ee18927bc0$var$DefaultTrigger, {
        open: open
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAJUP.ErrorBoundary), {
        fallbackRender: ()=>null
    }, triggerNode, isActivated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($760b34ee18927bc0$var$LazyRovoSettingsModalProvider, {
        ...providerProps,
        pendingOpenOptions: pendingOpenOptions,
        openModalRef: openModalRef
    })));
};
module.exports["RovoSettingsModal"] = $760b34ee18927bc0$export$f2c3f3e62df426ba;

});

parcelRegister("7ZiAi", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $c17fc71688854b9e$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    modalTitle: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.modal-title.non-final",
        defaultMessage: "Sources & apps"
    },
    searchPlaceholder: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.search-placeholder.non-final",
        defaultMessage: "Search settings"
    },
    defaultTriggerLabel: {
        id: "ai-mate.rovo-settings-modal.portable-rovo-settings.default-trigger-label.non-final",
        defaultMessage: "Explore all apps"
    }
});
module.exports["messages"] = $c17fc71688854b9e$export$defe85febe8b728c;

});

parcelRegister("4OJMa", function(module, exports) {

let $381f57188be92eb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $381f57188be92eb1$var$load("h3ABO"),
    $381f57188be92eb1$var$load("gXO4B"),
    $381f57188be92eb1$var$load("7nhGH"),
    $381f57188be92eb1$var$load("aMRFX"),
    $381f57188be92eb1$var$load("396ld"),
    $381f57188be92eb1$var$load("6wr18"),
    $381f57188be92eb1$var$load("4B7dP"),
    $381f57188be92eb1$var$load("2wyaQ"),
    $381f57188be92eb1$var$load("7EorR"),
    $381f57188be92eb1$var$load("9DBoM"),
    $381f57188be92eb1$var$load("ffEVr"),
    $381f57188be92eb1$var$load("a0cZb"),
    $381f57188be92eb1$var$load("RXMWr"),
    $381f57188be92eb1$var$load("hhss7"),
    $381f57188be92eb1$var$load("Wowvf"),
    $381f57188be92eb1$var$load("1F7LX"),
    $381f57188be92eb1$var$load("hXbzh"),
    $381f57188be92eb1$var$load("jnVKv")
]).then(()=>parcelRequire('7Bg2n'));

});


//# sourceMappingURL=ConnectorDeepLink.67358540.js.map
